import type { Category } from '../types/product';
import { IMG } from './images';

export const categories: Category[] = [
  { id: 'home-batteries', name: 'Home batteries', description: 'Store solar for the evening', image: IMG.home, fromPrice: 2149 },
  { id: 'plug-in', name: 'Plug-in batteries', description: 'No installer needed', image: IMG.plugin, fromPrice: 649 },
  { id: 'power-stations', name: 'Power stations', description: 'Camping, backup & off-grid', image: IMG.station, fromPrice: 199 },
  { id: 'solar-panels', name: 'Solar panels', description: 'Full black & TOPCon', image: IMG.solar, fromPrice: 99 },
  { id: 'inverters', name: 'Inverters', description: 'Hybrid & off-grid', image: IMG.inverter, fromPrice: 1190 },
  { id: 'accessories', name: 'Accessories', description: 'Cables, meters & mounts', image: IMG.accessory, fromPrice: 24.95 },
];
